import axios from 'axios'

export default {
    async me() {
        return await axios.get('user/me')
    },
    async create(first_name, last_name, email, roles, permissions, password) {
        return await axios.post(`user`, {
            first_name,
            last_name,
            email,
            roles,
            permissions,
            password,
        })
    },
    async fetchById(id) {
        return await axios.get(`user/${id}`)
    },
    async fetchPermissions(id) {
        return await axios.get(`user/${id}`)
    },
    async fetchUsers(query, page) {
        return await axios.get(`user?q=${query}&page=${page}`)
    },
    async fetchAll() {
        return await axios.get(`user/all`)
    },
    async updateEmail(userId, email) {
        return await axios.put(`user/${userId}/email`, {
            email,
        })
    },
    async unlockUserAccount(userId, is_locked) {
        return await axios.put(`user/${userId}/unlock-user`, {
            is_locked,
        })
    },
    async updateFirstTiemLogin(userId, is_first_time_login) {
        return await axios.put(`user/${userId}/update/login/flag`, {
            is_first_time_login,
        })
    },
    async updateBasicInfo({
        userId,
        is_blacklisted,
        first_name,
        last_name,
        roles,
        permissions,
    }) {
        console.log('userid', userId)
        return await axios.put(`user/${userId}`, {
            first_name,
            is_blacklisted,
            last_name,
            roles,
            permissions,
        })
    },
   
    async fetchDriverLocations() {
        async function getRole(id) {
            const result = await axios.get(`user/${id}`)
            let user = result.data.success.data
            return user.roles.length > 0 ? user.roles[0] : 'No Role'
        }
        const result = await axios.get(`user/drivers/location`)

        const drivers = result.data.success.data

        const driversRoles = await Promise.all(drivers.map(d => getRole(d.id)))

        return drivers.map((d, i) => {
            d.role = driversRoles[i].role.name
            return d
        })
    },
    async deleteUser(id) {
        console.log('delete', id)
        return await axios.delete(`user/${id}`, { crossdomain: true })
    },

    async updateLocation({ lat, long }) {
        await axios.put('user/me/update_location', { lat, long })
    },
    async updatePassword(userId, password) {
        return await axios.put(`user/${userId}/password`, {
            password,
        })
    },
}
